import { useMemo, useState } from "react";
import type { Deal, Partner } from "../types";
import { STAGES } from "../types";
import { useData } from "../hooks/useData";
import { clsx, fmtDate } from "../components/Primitives";

/** The pipeline as a list grouped by stage — the board doesn't fit a phone. Tap a deal for its page. */
export default function PhonePipeline({ go, partners, myId }: { go: (s: string, id?: string | null) => void; partners: Record<string, Partner>; myId: string }) {
  const { data: deals, error } = useData<Deal[]>("/api/deals");
  const [mine, setMine] = useState(false);
  const [q, setQ] = useState("");
  const groups = useMemo(() => {
    const s = q.trim().toLowerCase();
    const list = (deals || []).filter(d => (!mine || d.owner === myId) && (!s || [d.name, d.principal_name, d.market, d.operator_name].some(v => (v || "").toLowerCase().includes(s))));
    return STAGES.map(st => ({ ...st, deals: list.filter(d => d.stage === st.id) }));
  }, [deals, mine, q, myId]);

  if (error && !deals) return <div className="ph-pad"><div className="ph-note err">{error}</div></div>;
  if (!deals) return <div className="ph-pad"><div className="ph-skel" /><div className="ph-skel" /></div>;
  return (
    <div className="ph-pad">
      <div className="ph-searchrow">
        <input className="ph-input" type="search" placeholder="Search deals, principals, markets" value={q} onChange={e => setQ(e.target.value)} />
      </div>
      <div className="ph-seg">
        <button className={clsx(!mine && "on")} onClick={() => setMine(false)}>All deals</button>
        <button className={clsx(mine && "on")} onClick={() => setMine(true)}>Mine</button>
      </div>
      {groups.map(g => g.deals.length > 0 && (
        <section key={g.id}>
          <h2 className="ph-h2">{g.label} <span className="ph-count">{g.deals.length}</span></h2>
          <div className="ph-card">
            {g.deals.map(d => (
              <button key={d.id} className="ph-row ph-row-btn" onClick={() => go("project", d.id)}>
                <span className="ph-dot" style={{ background: d.principal_color || "var(--muted)" }} />
                <span className="ph-row-m">
                  <span className="ph-row-t">{d.name}</span>
                  <span className="ph-row-s">{[d.principal_name, d.market, partners[d.owner]?.name.split(" ")[0]].filter(Boolean).join(" · ")}</span>
                  {d.next_step && <span className="ph-row-s ph-next">Next: {d.next_step}{d.next_due ? ` · ${fmtDate(d.next_due)}` : ""}</span>}
                </span>
                <span className={clsx("ph-heat", d.heat)} title={d.heat} />
              </button>
            ))}
          </div>
        </section>
      ))}
      {groups.every(g => !g.deals.length) && <div className="ph-card ph-empty">No deals match.</div>}
      <button className="ph-btn ghost" onClick={() => go("countries")}>Markets ›</button>
      <button className="ph-btn ghost" onClick={() => go("principals")}>Principals ›</button>
    </div>
  );
}
